import React, { useState, useEffect } from 'react';
import { GelContainerLite, GelIcon, GelRowLayout, GelBoxLayout } from '@tal-gel/components';
import {pointerCursor, linkButton, leftNavContainer, leftNavHeaderText, leftNavInsuredNameText, leftNavProductPolicy, leftNavProductPolicyText, leftNavHeaderBackIcon, leftNavAccordionIcon, leftNavAccordionBox, existingBusinessQuote } from '../Shared/Styles';
import { isEmpty } from 'lodash';
import { Link, useRouteMatch } from "react-router-dom";

const SideNav = React.memo(({
  policyLives,
  distributorClientNo,
  policies,
  policyOrigin
}) => {
  const [lifeInsuredName, setLifeInsuredName] = useState("");
  const [productNamePolicyNum, setProductNamePolicyNum] = useState("");

  const [displayOptions, setDisplayOptions] = useState(true);
  const [displayDownloads, setDisplayDownloads] = useState(true);

  const toggleDisplayOptions = () => setDisplayOptions(!displayOptions);
  const toggleDisplayDownloads = () => setDisplayDownloads(!displayDownloads);

  const queryString = window.location.search;
  let { url } = useRouteMatch();

   const init = () => {
    if (policyLives && !isEmpty(policyLives)) {
      var policyLive = policyLives.find(e => e.distributorClientId.toString() === distributorClientNo);

      if (policyLive)
        setLifeInsuredName(policyLive.fullName);
    }

    if (policies && policies.length === 1) {
      setProductNamePolicyNum(policies[0].productName + ' | ' + policies[0].policyNumber);
    }
  };

  const menuFold = (menuItem) => {
    switch (menuItem) {
      case 'Options':
        toggleDisplayOptions();
        break;
      case 'Downloads':
        toggleDisplayDownloads();
        break;
      default:
        console.log(menuItem);
    };

  };

  useEffect(() => {
    try {
      init();
    }
    catch (error) {
      return (<div>error</div>);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [policyLives, policies]);

  return (
    <GelContainerLite style={leftNavContainer} gutter="none">
      <a href={`/dashboard/client-details${queryString}`} style={linkButton}>
        <GelRowLayout>
          <GelBoxLayout space="auto" distribution="start" gap="none">
            <GelIcon name="ChevronLeft" width={30} style={leftNavHeaderBackIcon} color='#6ac61c' />
            <div style={leftNavInsuredNameText}>{lifeInsuredName}</div>
          </GelBoxLayout>
        </GelRowLayout>
      </a>
      {
      (policyOrigin === 'TAL') ?
      <a href={`/dashboard/policy-record${queryString}`} style={linkButton}>
        <GelRowLayout >
          <GelBoxLayout space="auto" distribution="start" gap="none" style={leftNavProductPolicy}>
            <GelIcon name="ChevronLeft" width={30} style={leftNavHeaderBackIcon} color="#000" />
            <div style={leftNavProductPolicyText}>{productNamePolicyNum}</div>
          </GelBoxLayout>
        </GelRowLayout>      
      </a>  
      :
      <Link to={`/dashboard/policy-details${queryString}`} style={linkButton}>
        <GelRowLayout >
          <GelBoxLayout space="auto" distribution="start" gap="none" style={leftNavProductPolicy}>
            <GelIcon name="ChevronLeft" width={30} style={leftNavHeaderBackIcon} color="#000" />
            <div style={leftNavProductPolicyText}>{productNamePolicyNum}</div>
          </GelBoxLayout>
        </GelRowLayout>
      </Link>
      }
      {/* removing for TACO-5400
      <div onClick={menuFold.bind(this, 'Options')} style={pointerCursor} >
        <GelRowLayout >
          <GelBoxLayout space="auto" distribution="spaceBetween" >
            <div style={leftNavHeaderText}>Options</div>
            <GelIcon name={(displayOptions) ? "ChevronUp" : "ChevronDown"} width={30} style={leftNavAccordionIcon} color="#fff" />
          </GelBoxLayout>
        </GelRowLayout>
      </div> */}
      {/* { (displayOptions) ?
      <Link to={`${url}/alter-policy${queryString}`}>
        <GelRowLayout>
          <GelBoxLayout space="auto" distribution="start" style={leftNavAccordionBox}>
            <span style={leftNavHeaderText}>
              Alter Policy</span>
            <GelIcon name="Minus" width={30} style={leftNavAccordionIcon} color="#445058" />
          </GelBoxLayout>
        </GelRowLayout>
      </Link>
      : null
      }
       { (displayOptions) ?
      <Link to={`${url}/request-existing-business-quote${queryString}`}>
        <GelRowLayout>
          <GelBoxLayout space="auto" distribution="start" style={leftNavAccordionBox}>
            <span style={existingBusinessQuote}>
              Request Existing Business Quote</span>
            <GelIcon name="Minus" width={30} style={leftNavAccordionIcon} color="#445058" />
          </GelBoxLayout>
        </GelRowLayout>
      </Link>
      : null
      } */}
      {/* <div onClick={menuFold.bind(this, 'Downloads')} style={pointerCursor} >
        <GelRowLayout>
          <GelBoxLayout space="auto" distribution="spaceBetween" >
            <div style={leftNavHeaderText}>Downloads</div>
            <GelIcon name={(displayDownloads) ? "ChevronUp" : "ChevronDown"} width={30} style={leftNavAccordionIcon} color="#fff" />
          </GelBoxLayout>
        </GelRowLayout>
      </div> */}
      {/* { (displayDownloads) ? 
      <a target="_blank" rel="noreferrer" href={`/dashboard/pds-documents-asteron${queryString}`}>
        <GelRowLayout>
          <GelBoxLayout space="auto" distribution="start" style={leftNavAccordionBox}>
            <span style={leftNavHeaderText} >
              Product Disclosure Statement</span>
            <GelIcon name="Minus" width={30} style={leftNavAccordionIcon} color="#445058" />
          </GelBoxLayout>
        </GelRowLayout>
      </a>
      : null } */}
    </GelContainerLite>
  );
});

export default SideNav;